import type { RouteRecord } from "vite-react-ssg"

import DataProvider from "./providers/DataProvider/DataProvider";
import AppLayout from "./components/AppLayout/AppLayout";
import HomePage from "./pages/HomePage";
import RoomsPage from "./pages/RoomsPage";
import OutsidePage from "./pages/OutsidePage";
import ContactPage from "./pages/ContactPage";
import BookPage from "./pages/BookPage";


// Cada grupo es una ruta "sin path" (solo layout): agrupa las páginas de un
// mismo idioma bajo un único 'AppLayout' + 'DataProvider', que React Router
// mantiene montado mientras se navega entre ellas.
export const staticRoutes: RouteRecord[] = [
    {
        element: <DataProvider lang="es"><AppLayout/></DataProvider>,
        children: [
            { path: "/", element: <HomePage/> },
        ]
    },



    {
        element: <DataProvider lang="es"><AppLayout/></DataProvider>,
        children: [
            { path: "/es/inicio/", element: <HomePage/> },
            { path: "/es/departamentos/", element: <RoomsPage/> },
            { path: "/es/exterior", element: <OutsidePage/> },
            { path: "/es/contacto/", element: <ContactPage/> },
            { path: "/es/reservar/", element: <BookPage/> },
        ]
    },



    {
        element: <DataProvider lang="en"><AppLayout/></DataProvider>,
        children: [
            { path: "/en/home/", element: <HomePage/> },
            { path: "/en/rooms/", element: <RoomsPage/> },
            { path: "/en/outdoor", element: <OutsidePage/> },
            { path: "/en/contact/", element: <ContactPage/> },
            { path: "/en/book/", element: <BookPage/> },
        ]
    },


    {
        element: <DataProvider lang="pt"><AppLayout/></DataProvider>,
        children: [
            { path: "/pt/inicio/", element: <HomePage/> },
            { path: "/pt/quartos/", element: <RoomsPage/> },
            { path: "/pt/exterior", element: <OutsidePage/> },
            { path: "/pt/contato/", element: <ContactPage/> },
            { path: "/pt/reservar/", element: <BookPage/> },
        ]
    },
];
